var _defs, _polygon, _g, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoiteBiscuits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    "data-name": "Calque 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 601 322.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f2a870;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#705045;}.cls-5{fill:#3a2621;}.cls-6{fill:#f2bf75;}.cls-7,.cls-8{fill:#ce5e32;}.cls-8{opacity:0.64;}.cls-9{fill:#fff;}.cls-10{fill:#aa5237;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1057 -1245.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1297.8,1422.52q-22.93-8.82-6.08-27.65l1.68-2.72c3.2-17.66,28.55-28.29,56.32-30.29,18.69-1.64,36,1.16,52.55,6.14,16.69-23.4,56.31-30.3,80-20.34,26.3,11.07,38.22,22.16,34.46,40.74-2.93,8.28-8.91,12.6-12.72,15.18-3.07,4.86-9.35,9.75-16.9,13-29.17,13.2-57.88,11.39-83.56-2.46-3.49,2.95-6.82,4.7-12.49,7.67a7.69,7.69,0,0,1-5.31-.33c-5.71-5.33-17.41-7.74-32.24-8.62q-24.72-1.08-49.81,9.07A8.78,8.78,0,0,1,1297.8,1422.52Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boite biscuits") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 246.92 0 163.99 207.32 0 601 71.75 601 155.61 420.7 322.4 0 246.92"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1297.8,1422.52q-22.93-8.82-6.08-27.65l1.68-2.72c3.2-17.66,28.55-28.29,56.32-30.29,18.69-1.64,36,1.16,52.55,6.14,16.69-23.4,56.31-30.3,80-20.34,26.3,11.07,38.22,22.16,34.46,40.74-2.93,8.28-8.91,12.6-12.72,15.18-3.07,4.86-9.35,9.75-16.9,13-29.17,13.2-57.88,11.39-83.56-2.46-3.49,2.95-6.82,4.7-12.49,7.67a7.69,7.69,0,0,1-5.31-.33c-5.71-5.33-17.41-7.74-32.24-8.62q-24.72-1.08-49.81,9.07A8.78,8.78,0,0,1,1297.8,1422.52Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1399,1409s-3,9-10,9-19-15-63-5c-19,4-20,6-26,7-6,0-13.84-7.2-15.42-11.6S1277,1419,1277,1419l23,14s34,2,38,2,64-8,64-8l2.57-12.29a13.39,13.39,0,0,1-5.07-4.7A10.54,10.54,0,0,1,1399,1409Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1306,1402c16-6,67-13,90-2l2,8s-29-6-30-5-55,4-55,4l-7,3-12-6-1-9,.62-3.93S1296,1401,1306,1402Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1504,1404s-32.29,22.66-94,8a27.17,27.17,0,0,1-13-8s3,8,7,13,63,14,63,14l42-18Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1400,1378c17,39.78,102,42,117.11,8l1.89,4s-4,11-6,12-28,12-28,12l-21.41,2.34L1425,1411l-21-15-5-13Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1293.4,1392.15v.53c.08,6.63,2,12.81,12.3,15.3,15.25-4.13,27.43-8.62,53-8.88s27.62,2.4,38.67,7.15l1.51,2.91c-2.15,2.7-5.38,3-9.13,2.25-20.63-11.3-53-7.12-81.6,3.3C1294.9,1413.17,1289.46,1406,1293.4,1392.15Z",
    transform: "translate(-1057 -1245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1401,1373.56c-7.35,31.51,61.2,54.65,103,30C1462,1437.6,1380.31,1407.05,1401,1373.56Z",
    transform: "translate(-1057 -1245.01)"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "0 163.58 413.71 241.85 601 71.34 601 155.2 420.7 321.99 0 246.51 0 163.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "150.11 183.25 323 30.99 211 11.99 28.75 160.99 150.11 183.25"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "549 107.99 302 57.99 328.78 33.44 582 76.99 549 107.99"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "428 248.99 428 305.99 591 154.99 591 92.99 428 248.99"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "15 235.99 15 182.99 395 252.99 395 305.99 15 235.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiteBiscuits);
export default __webpack_public_path__ + "static/media/boite_biscuits.aa26449f8360676dac224fba843e54bd.svg";
export { ForwardRef as ReactComponent };